import styled from 'styled-components'

const List = styled.ul`
  border: 1px solid #ccc;
  overflow-x: hidden;
  overflow-y: scroll;
`

export default List
